import React, { useState } from 'react'
import AppContext from './AppContext'

const AppProvider = ({ children }) => {
  const initialStoreState = {}

  const [store] = useState(initialStoreState)

  return (
    <AppContext.Provider
      value={{
        store
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
export default AppProvider
